import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forWho = ['Acabas de empezar con la píldora', 'Llevas tiempo tomándola pero tienes dudas', 'Has olvidado pastillas y no supiste qué hacer', 'Quieres un sistema para nunca más olvidarla', 'Quieres información confiable sin buscar en Google', 'Quieres dejar el miedo y empezar a saber'];
const notForWho = ['Si buscas reemplazar la consulta médica', 'Si quieres recetas o diagnósticos', 'Si no estás dispuesta a aplicar la información'];
export function ForWho() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-87">
      <div className="text-center mb-16" data-id="element-88">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark" data-id="element-89">
          Esta guía ES para ti si...
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-[16px] p-8 shadow-md border-t-4 border-brand-success" data-id="element-91">
          <ul className="space-y-6" data-id="element-92">
            {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-93">
                <div className="bg-brand-success/10 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-94">
                  <Check className="w-5 h-5 text-brand-success" data-id="element-95" />
                </div>
                <span className="text-lg text-brand-dark font-medium" data-id="element-96">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="bg-white/60 rounded-[16px] p-8 shadow-sm border-t-4 border-brand-danger/50" data-id="element-97">
          <h3 className="text-xl font-bold text-brand-dark/70 mb-6" data-id="element-98">
            NO es para ti si:
          </h3>
          <ul className="space-y-6" data-id="element-99">
            {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4 opacity-80" data-id="element-100">
                <div className="bg-brand-danger/10 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-101">
                  <X className="w-5 h-5 text-brand-danger" data-id="element-102" />
                </div>
                <span className="text-lg text-brand-secondary" data-id="element-103">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}